// extracted by mini-css-extract-plugin
export default {"labelRow":"XJb1tS9lTiuFZKc3LZ7B","label":"xl_sT9Fq5omw6K6AnsK0","value":"diKywI5rmxEawacIlR2w"};